import React from 'react';
import {Filter, FilterProps} from 'react-admin';

const PriceListFactorsFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <></>
    </Filter>
);

export default PriceListFactorsFilter;
